// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-pill-button----styles-module---container---3fNAO","small":"src-components-pill-button----styles-module---small---11cws","theme-blue":"src-components-pill-button----styles-module---theme-blue---2YbUK","theme-black-ghost":"src-components-pill-button----styles-module---theme-black-ghost---1hGsx","theme-grey-ghost":"src-components-pill-button----styles-module---theme-grey-ghost---1nbJH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pill-button/styles.module.css
// module id = 631
// module chunks = 168707334958949